(function () {
  'use strict';

  angular
    .module('app.authentication', [])

    /* @ngInject */
    .controller('authenticationCtrl', ["$scope", "$timeout", function ($scope, $timeout) {
      var ctrl = this;
      ctrl.newClient = {};
      ctrl.templateCreate = '';
      ctrl.createOpen = false;

      ctrl.loadedAccountCreate = function () {
        $scope.$emit('showPageLoader', false);
        $timeout(function () {
          ctrl.createOpen = true;
        });
      };
      ctrl.toggleAccountCreate = function () {
        ctrl.createOpen = !ctrl.createOpen;
      };
    }])

    /* @ngInject */
    .controller('loginCtrl', ["$scope", "$rootScope", "$timeout", "$location", "$uibModal", "AccountService", "AppService", "LogService", function ($scope, $rootScope, $timeout, $location, $uibModal, AccountService, AppService, LogService) {

      $timeout(function () {
        $rootScope.$broadcast('showPageLoader', false);
      }, 500);

      $scope.formData = {
        RememberMe: false,
        errors: []
      };

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function (event) {
        $(event.target).find('input').blur();
        $scope.showLoader = true;
        LogService.login($scope.formData)
          .then(function (response) {
            if (response.status === 'OK') {
              $rootScope.$broadcast('login');
              AppService.getParams(true)
                .then(function (data) {
                  if (LogService.redirect) {
                    if (LogService.redirect.url) $location.path(LogService.redirect.url).replace();
                    if (LogService.redirect.action) LogService.redirect.action();
                    LogService.redirect = null;
                  } else {
                    $location.path(AccountService.getLinks().AccountHome).replace();
                  }
                  $scope.showLoader = false;
                })
                .catch(function (error) {
                  console.error(error);
                });
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                  $scope.showLoader = false;
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      $scope.openForgotPassword = function () {
        LogService.email = $scope.formData.Login;
        $uibModal.open({
          templateUrl: '/Template/Authentication/ModalForgotPassword',
          controller: 'forgotPasswordModalCtrl'
        });
      };

    }])

    /* @ngInject */
    .controller('loginModalCtrl', ["$scope", "$rootScope", "$location", "$uibModal", "$uibModalInstance", "$route", "AppService", "LogService", "RoutesService", function ($scope, $rootScope, $location, $uibModal, $uibModalInstance, $route, AppService, LogService, RoutesService) {

      $scope.linkCreate = '/' + RoutesService.get().Login.url;

      $scope.formData = {
        RememberMe: false,
        errors: [],
        returnUrl: '/'
      };

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function (event) {
        $(event.target).find('input').blur();
        $scope.showLoader = true;
        LogService.login($scope.formData)
          .then(function (response) {
            if (response.status === 'OK') {
              $uibModalInstance.close();
              $rootScope.$broadcast('login');
              AppService.getParams(true)
                .then(function (data) {
                  if (LogService.redirect) {
                    if (LogService.redirect.url) $location.path(LogService.redirect.url).replace();
                    if (LogService.redirect.action) LogService.redirect.action();
                    LogService.redirect = null;
                  } else {
                    $route.reload();
                  }
                })
                .catch(function (error) {
                  console.error(error);
                });
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
            $scope.showLoader = false;
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      $scope.openForgotPassword = function () {
        LogService.email = $scope.formData.Login;
        $uibModalInstance.closed.then(function () {
          $uibModal.open({
            templateUrl: '/Template/Authentication/ModalForgotPassword',
            controller: 'forgotPasswordModalCtrl'
          });
        });
        $uibModalInstance.close();
      };

    }])

    /* @ngInject */
    .controller('newClientCtrl', ["$scope", "HttpService", "AppService", function ($scope, HttpService, AppService) {

      $scope.formData = {
        errors: []
      };

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function (event) {

        $(event.target).find('input').blur();
        $scope.$emit('showPageLoader', true);

        HttpService.post({
          url: '/TestMailExist',
          data: $scope.auth.newClient
        })
        .then(function (response) {
          if (response.status === 'OK') {
            $scope.showCreate();
          } else {
            $scope.$emit('showPageLoader', false);
            AppService.getTranslate()
              .then(function (translate) {
                for (var fieldName in response.errors) {
                  if (fieldName === 'Global') {
                    var error = response.errors[fieldName].Errors[0].ErrorMessage;
                    $scope.formData.errors[fieldName] = translate.errors[error];
                  }
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      };

      $scope.showCreate = function () {
        if ($scope.auth.templateCreate === '') {
          $scope.$emit('showPageLoader', true);
          $scope.auth.templateCreate = '/AccountCreate';
        } else {
          $scope.$emit('showPageLoader', false);
          $scope.auth.createOpen = true;
        }
      };

    }])

    /* @ngInject */
    .controller('forgotPasswordModalCtrl', ["$scope", "HttpService", "$uibModal", "$uibModalInstance", "AppService", "LogService", function ($scope, HttpService, $uibModal, $uibModalInstance, AppService, LogService) {

      $scope.formData = {
        errors: []
      };
      $scope.formData.Email = LogService.email;

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function () {

        $scope.showLoader = true;

        HttpService.post({
          url: '/ForgotPassword',
          data: $scope.formData
        })
        .then(function (response) {
          if (response.status === 'OK') {
            $uibModalInstance.closed.then(function () {
              $uibModal.open({
                templateUrl: '/Template/Authentication/ModalForgotPasswordConfirm'
              });
            });
            $uibModalInstance.close();
          } else {
            AppService.getTranslate()
              .then(function (translate) {
                for (var fieldName in response.errors) {
                  if (fieldName === 'Global') {
                    var error = response.errors[fieldName].Errors[0].ErrorMessage;
                    $scope.formData.errors[fieldName] = translate.errors[error];
                  }
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }
          $scope.showLoader = false;
        })
        .catch(function (error) {
          console.error(error);
        });

      };

    }]);

})();
